import React, { useState } from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { AddSucursalIcon } from '../../../../assets/svg/iconos';

import { VacacionalItem } from './VacacionalItem';
import { getDefaultProfessionalHours } from '../horariosExtra/HorarioExtra';

const timezone = process.env.REACT_APP_TIMEZONE;

export const Vacacional = ({ editMode, objProfesional, descansosTemp, setDescansosTemp, deleteVacaciones, horariosExtraTemp, setHorariosExtraTemp, deleteHorarioExtra }) => {
    const { colores } = useSelector( state => state.ui );
    const { uid } = useSelector( state => state.auth );

    const [contadorNewItems, setContadorNewItems] = useState(0);

    const addDescanso = () => {
        // Por defecto la ausencia se crea en jornada completa (00:00-23:59). El usuario puede
        // ajustar el rango a unas horas concretas desmarcando "Toda la jornada".
        const fechaBase = moment().tz(timezone).startOf('day');
        const fechaInicio = fechaBase.clone()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0);
        const fechaFin = fechaBase.clone()
            .hours(23)
            .minutes(59)
            .seconds(0)
            .milliseconds(0);

        const newDescanso = {
            empresa: objProfesional.empresa,
            diasSemana: [],
            fechaInicio: fechaInicio.toISOString(),
            fechaFin: fechaFin.toISOString(),
            festivo: false,
            profesional: objProfesional._id,
            profesionalSucursals: [],
            repetir: false,
            tipo: 'ausencia',
            usuario: uid,
            _id: `new-${contadorNewItems}`
        };

        setDescansosTemp([
            newDescanso,
            ...descansosTemp
        ]);

        setContadorNewItems( contadorNewItems + 1 );
    }

    const addItem = () => {
        addDescanso();
    }

    const editDescanso = ( descanso ) => {
        setDescansosTemp(
            descansosTemp.map( des => {
                if( des._id === descanso._id ){
                    return descanso;
                }
                return des;
            })
        )
    }

    const editHorarioExtra = ( horarioExtra ) => {
        setHorariosExtraTemp(
            horariosExtraTemp.map( he => {
                if( he._id === horarioExtra._id ){
                    return horarioExtra;
                }
                return he;
            })
        )
    }

    const convertDescansoToHorarioExtra = (descanso) => {
        const fechaDescanso = moment.tz(descanso.fechaInicio, timezone);
        const { horaInicioDefault, horaFinDefault } = getDefaultProfessionalHours(objProfesional, fechaDescanso);
        
        const fechaBase = fechaDescanso.clone().startOf('day');
        const initialFechaInicio = fechaBase.clone()
            .hours(horaInicioDefault.hours())
            .minutes(horaInicioDefault.minutes())
            .seconds(0)
            .milliseconds(0)
            .toDate();
        const initialFechaFin = fechaBase.clone()
            .hours(horaFinDefault.hours())
            .minutes(horaFinDefault.minutes())
            .seconds(0)
            .milliseconds(0)
            .toDate();

        const newHorarioExtra = {
            empresa: objProfesional.empresa,
            profesional: objProfesional.usuario || objProfesional._id,
            fechaFin: moment.tz(descanso.fechaFin, timezone).toISOString(),
            fechaInicio: moment.tz(descanso.fechaInicio, timezone).toISOString(),
            horaInicio: moment.tz(initialFechaInicio, timezone).toISOString(),
            horaFin: moment.tz(initialFechaFin, timezone).toISOString(),
            todaJornada: false,
            repetir: descanso.repetir || false,
            diasSemana: descanso.diasSemana || [],
            tipo: 'horario_extra',
            _id: descanso._id
        };

        setDescansosTemp(descansosTemp.filter(d => d._id !== descanso._id));
        setHorariosExtraTemp([...horariosExtraTemp, newHorarioExtra]);
    }

    const convertHorarioExtraToDescanso = (horarioExtra, nuevoTipo) => {
        let fechaInicio = moment.tz(horarioExtra.fechaInicio, timezone).toISOString();
        let fechaFin = moment.tz(horarioExtra.fechaFin, timezone).toISOString();

        if (nuevoTipo === 'ausencia') {
            const fechaBase = moment.tz(horarioExtra.fechaInicio, timezone);
            fechaInicio = fechaBase.clone().hours(0).minutes(0).seconds(0).toISOString();
            fechaFin = fechaBase.clone().hours(23).minutes(59).seconds(0).toISOString();
        }

        const newDescanso = {
            empresa: objProfesional.empresa,
            diasSemana: horarioExtra.diasSemana || [],
            fechaFin: fechaFin,
            fechaInicio: fechaInicio,
            festivo: false,
            profesional: objProfesional._id,
            profesionalSucursals: [],
            repetir: horarioExtra.repetir || false,
            tipo: nuevoTipo,
            usuario: uid,
            _id: horarioExtra._id
        };

        setHorariosExtraTemp(horariosExtraTemp.filter(he => he._id !== horarioExtra._id));
        setDescansosTemp([...descansosTemp, newDescanso]);
    }
    

    return (
        <div className='vacacional'>
            <div
                style={{ 
                    backgroundColor: colores.color6,
                    color: colores.colorPrincipal
                }}
                className={`vacacional-add`}
            >
                <p>Añadir</p>
                <span
                    onClick={ () => addItem() }
                ><AddSucursalIcon color={ colores.colorPrincipal } /></span>
            </div>
            {
                [
                    ...descansosTemp.filter(descanso => descanso.tipo !== 'horario_extra'),
                    ...(horariosExtraTemp || [])
                ].map( (item) => {
                    const isHorarioExtra = item.tipo === 'horario_extra';
                    return (
                        <VacacionalItem
                            key={ item._id }
                            editMode={ editMode }
                            descanso = { item }
                            descansosTemp = { descansosTemp }
                            editDescanso = { editDescanso }
                            deleteVacaciones={ deleteVacaciones }
                            onConvertToHorarioExtra={ convertDescansoToHorarioExtra }
                            objProfesional={ objProfesional }
                            isHorarioExtra={ isHorarioExtra }
                            editHorarioExtra={ editHorarioExtra }
                            deleteHorarioExtra={ deleteHorarioExtra }
                            horariosExtraTemp={ horariosExtraTemp }
                            onConvertToDescanso={ convertHorarioExtraToDescanso }
                        />
                    );
                })
            }
        </div>
    )
}
